import { render, staticRenderFns } from "./receive-status.vue?vue&type=template&id=198f0cf8&scoped=true&"
import script from "./receive-status.vue?vue&type=script&lang=js&"
export * from "./receive-status.vue?vue&type=script&lang=js&"
import style0 from "./receive-status.vue?vue&type=style&index=0&id=198f0cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198f0cf8",
  null
  
)

export default component.exports